import { Navigate } from "react-router-dom";
import ConsoleHelper from "utils/ConsoleHelper";

function RequireAuthButNotVerified({ children, isAuth, isVerified }) {
  // If not authenticated => go to login
  if (!isAuth) {
    ConsoleHelper("RequireAuthButNotVerified", "User is not authenticated");
    return <Navigate to="/auth/login" replace />;
  }
  // If already verified => maybe go to subscription or main area
  if (isVerified) {
    ConsoleHelper("RequireAuthButNotVerified", "User is already verified");
    return <Navigate to="/app" replace />;
  }
  ConsoleHelper(
    "RequireAuthButNotVerified",
    "User is authenticated but not verified"
  );
  // If authenticated but not verified => show child
  return children;
}

export default RequireAuthButNotVerified;
